import React from 'react';
import './Project.css'
import { Link } from 'react-router-dom';

const Project = (props) => {
    // const { name, img, category } = project
    console.log(props)
    return (
        <div data-aos="fade-in" data-aos-duration="3000" className='col-md-6 home-project-card'>
            <Link to={`/projectView/${props.project.id}`}>

                <div className='home-project-card-textBox'>
                    <p className='home-project-text-1'>{(props.project?.category)}</p>
                    <h5 className='home-project-text-2'>{(props.project?.name)}</h5>
                </div>
            </Link>
            <h3 className='blank'>&nbsp; &nbsp; &nbsp;  </h3>

            <Link to={`/projectView/${props.project.id}`}>
                <div>
                    <img className='home-project-card-img' src={(props.project?.img)} alt="" />

                </div>
            </Link>
        </div>
    );
};

export default Project;